export const GEOGRAPHICAL_MIDDLE_OF_BELGIUM = {
    latitude: 50.6401661,
    longitude: 4.6666977
}